export const sort = (data, column, directionNumb) => {
    return data && [...data].sort((a, b) => {
        if (a[column] === b[column]) {
            return 0;
        }
        return a[column] > b[column] ? directionNumb : directionNumb * -1;
    });
};